import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import api from "api";
import PaymentLinkForm from "./../inc/PaymentLinkForm";

export default function SendPaymentLinkModal({

  orderId,
  onClose,
  onSuccess
}) {
  const [order, setOrder] = useState(null);
  const getOrder = async () => {
    const res = await api.get(`/order/${orderId}`);
    if (res.data && res.data?.orderId) {
      setOrder(res.data)
    }
  }
  useEffect(() => {

    if (orderId) {
      getOrder();
    }

  }, [orderId])
  if (!order) {
    return null;
  }
  const defaultRecipient = {
    recipientFirstname: order.orderBillingFirstname,
    recipientLastname: order.orderBillingLastname,
    recipientEmail: order.orderBillingEmail
  };
  return (

    <Modal show={true} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Envoyer un lien de paiement
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-3">
          <div className="small text-muted">
            Réf : {order.orderRef}
          </div>
          <div className="fw-bold">
            Solde à payer : {order.orderBalance} €
          </div>
        </div>

        <PaymentLinkForm
          orderId={order.orderId}
          orderBalance={order.orderBalance}
          defaultRecipient={defaultRecipient}
          onSuccess={(data) => {
            onSuccess && onSuccess(data);
            onClose && onClose();
          }}
          onCancel={onClose}
        />
      </Modal.Body>
    </Modal>

  );
}